import { h, Component, } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {Form, Button, I18n, FormEntry, Col, Row, Divider, Container, Toggle } from 'components/elements' 
import {connect} from 'react-redux'
import {AccountActions} from 'actions'
import style from './style.less'
import countries from 'lib/countries'
import { formatPhoneNumber } from 'lib/helpers';
import {FACheckCircle, FADotCircle, FASpinner} from 'components/elements/FontAwesome'
import _ from 'lodash'

import ConfirmAuthenticators from '../ConfirmAuthenticator';

// Icons
import editIcon from "../../../assets/icons/svg/edit.svg";
import showIcon from "../../../assets/icons/svg/eye.svg";
import hideIcon from "../../../assets/icons/svg/eye_off.svg";


const Fragment = h.Fragment = 'x-fragment'

let mapInputType = {
    Dropdown: 'text',
    String: 'text',
    Integer: 'number',
    Float: 'number'
}

@Form
@connect((state)=> state)
export default class ContactInformation extends WidgetComponent {
    constructor(){
        super()
        this.state = {
            editing: false,
            grantError: false,
            passwordError: false,
            emailError: false,
            phoneError: false,
            accessToggled: false,
            showPassword: false,
            customBooleans: {},
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleToggleEdit = this.handleToggleEdit.bind(this)
        this.handleError = this.handleError.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleMobileChange = this.handleMobileChange.bind(this)
        this.handleToggleAccess = this.handleToggleAccess.bind(this)
        this.handleStateSearch = this.handleStateSearch.bind(this)
        this.handlePassword = this.handlePassword.bind(this)
        this.handlePasswordConfirmation = this.handlePasswordConfirmation.bind(this)
        this.handleConfirmAuthenticatorsSubmit = this.handleConfirmAuthenticatorsSubmit.bind(this)
        this.handleShowPassword = this.handleShowPassword.bind(this)
    }

    componentWillMount(){
        if(!this.props.finishedClient){
            let requiredFields = ['firstName', 'lastName', 'address', 'city', 'state', 'zip', 'mobilePhone', 'email']
            let customBooleans = {}
            for(let customField of this.customFields){
                if(customField.type == 'Boolean'){
                    customBooleans[customField.key] = this.account[customField.key] || false
                }
                if(customField.required){
                    requiredFields.push(customField.key)
                }
            }
    
            this.setState({
                customBooleans
            })
            const exist = _.every(requiredFields, (a) =>{
                return (this.session.account || {})[a] 
            })
            let orgHasAccess = false
            for(let organization of (this.props.session.organizations || [])){
                if(organization.id == this.props.config.organizationID){
                    orgHasAccess = true
                }
            }

            if (this.props.page !== "confirmation" && (!this.session.accessToken || !exist || !orgHasAccess)) {
                this.setState({
                    editing: true
                })
            } else {
                super.componentDidSubmit()
                this.props.onSubmit && this.props.onSubmit()
            }
        }
    }

    grantAccess (e) {
        return AccountActions.grant({organizationID: this.props.organization.id})
    };

    get account() {
        let data = {
            ...(this.session.account || {})
        }
        return data;
    }

    get session(){
        return (this.props.session || {})
    }

    get organizationAccess() {
        if(!(this.session.organizations || []).some((organization)=>{ return organization.id == this.props.organization.id})){
            return false
        }
        return true
    }

    get organization(){
        return this.props.organization || {country: 'US'}
    }
    
    get states(){
        return countries.statesOrProvinces(this.organization.country)
        .map((state)=>({name: state.name, value: state.code}))
    }

    get stateValue(){
        return this.state.stateSearch || this.account.state || ''
    }
    
    get customFields(){
        return Object.values(this.props.customFields || {}).filter((customField)=>{
            return customField.model == 'Account'
        }).sort((a,b)=>{
            if(a.type == 'Boolean') return 1
            if(b.type == 'Boolean') return -1
            return 0
        })
    }

    handleToggleCustomField(customField, e){
        this.setState({
            customBooleans: {
                ...this.state.customBooleans,
                [customField.key]: !this.state.customBooleans[customField.key]
            }
        })
    }

    handleStateSearch(value){
        this.setState({
            stateSearch: value
        })
    }

    handleToggleAccess(){
        this.setState({
            accessToggled: !this.state.accessToggled,
            toggleError: false
        })
    }

    handleGrantAccess (e) {
        e.preventDefault()
        
        return AccountActions.grant({
            organizationID: this.props.organization.id
        })
    };

    handleSubmit(values){
        if(this.componentIsLoading()){
            return
        }
        Object.keys(values).forEach((key)=>{
            if(_.isNil(values[key])){
                delete values[key]
            }
        })

        if(values.mobilePhone){
            values.mobilePhone = values.mobilePhone.replaceAll('-','')
        }

        let data = {
            ...this.props.session.account,
            ...values,
            ...this.state.customBooleans
        }

        AccountActions.set({...data})

        this.setState({
            passwordError: false,
            grantError: false,
        })
        this.componentWillSubmit().then((r)=>{
            if(!this.organizationAccess && !this.state.accessToggled){
                this.setState({
                    grantError: 'You must grant access to continue'
                })
                this.componentFailedToSubmit()
            } else if(this.account.id){
                this.grantAccess().then(()=>{
                    return AccountActions.update({...data})
                }).then((response)=>{
                    if(!this.organizationAccess){
                        return this.grantAccess()
                    }
                })
                .then((res)=>{
                    this.setState({
                        editing: false
                    })
                    super.componentDidSubmit()
                    this.props.onSubmit && this.props.onSubmit()
                })
                .catch((e)=>{
                    this.componentFailedToSubmit(e)
                    this.handleError(e)
                })
            } else {
                if(values.password === values.passwordConfirmation){
                    AccountActions.create({...data}).then((response)=>{
                        this.setState({
                            editing: false
                        })
                        super.componentDidSubmit()
                        this.props.onSubmit && this.props.onSubmit()
                    })
                    .catch((e)=>{
                        this.componentFailedToSubmit(e)
                        this.handleError(e)
                    })
                } else if (values.password != values.passwordConfirmation){
                    this.setState({
                        passwordError: 'Passwords do not match'
                    })
                    this.componentFailedToSubmit()
                }
            }
        })
        
    }

    handleToggleEdit(e){
        if(!e || e.target.id == "contact-edit" || 
            e.target.parentElement.id == "contact-edit"){
            this.setState({
                editing: !this.state.editing
            })
        }
    }

    handleError(e){
        if(e.response){
            e = (e.response.data || {}).errors || ''
            if(e.includes('email')){
                this.setState({
                    emailError: true
                })
            }
            if(e.includes('mobilePhone')){
                this.setState({
                    phoneError: true
                })
            }
            if(Array.isArray(e)){
                let errorMessage = []
    
                if(e.includes("min")){
                    errorMessage.push("Must be at least 8 characters")
                }
                if(e.includes("uppercase")){
                    errorMessage.push("Must have at least 1 upper case character")
                }
                if(e.includes("digits")){
                    errorMessage.push("Must have at least 1 digit")
                }
                if(e.includes("specialCharacter")){
                    errorMessage.push("Must have at least 1 special character")
                }
                this.setState({
                    passwordError: `Invalid Password: ${errorMessage.join(", ")}`
                })
            }
            
            if(!e){
                this.setState({
                    passwordError: `An unknown error has occured`
                })
            }
        }
    }

    handleMobileChange(){
        if(this.state.phoneError){
            this.setState({
                phoneError: false
            })
        }
    }

    handleEmailChange(){
        if(this.state.emailError){
            this.setState({
                emailError: false
            })
        }
    }

    handlePassword(e){
        const value = e.target.value
        this.setState({
            passwordValue: value,
            passwordConfirmationMatches: value == this.state.passwordConfirmationValue,
            hasNumber: value.match(/(?=.*\d)/),
            hasLowerCase: value.match(/(?=.*[a-z])/),
            hasUpperCase: value.match(/(?=.*[A-Z])/),
            hasEightCharacters:  value.match(/(?=.{8,8})/)
        })
    }

    handlePasswordConfirmation(e){
        const value = e.target.value
        this.setState({
            passwordConfirmationValue: value,
            passwordConfirmationMatches: value == this.state.passwordValue
        })
    }

    handleShowPassword(){
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    handleConfirmAuthenticatorsSubmit(e){
        this.setState({
            editing: false
        })
        super.componentDidSubmit()
        this.props.onSubmit && this.props.onSubmit()
    }

    get confirmAuthenticators(){
        const messages = this.props.session.messages
        if(messages && messages.length > 0){
            let confirmAuthenticators = []
            for(let message of messages){  
                if(message.type && message.type.includes('authenticatorOwnershipRequest')){
                    confirmAuthenticators.push(message.type.split('.')[1])
                }
            }
            if(confirmAuthenticators.length > 0){
                return confirmAuthenticators  // Get the authenticator type
            }
        }
        return null
    }
    render() {
        const {Form, MaskedInputDark, InputDark, SelectDark} = this.props
        return (
            <Container title='Contact Information' key={this.props.containerKey} class={style.contactInformationContainer}>
                <Form id={this.account.id || 'newAccount'} class={style.contactForm} onSubmit={this.handleSubmit} >
                    <div className={style.contactContainer} >
                        <div className={style.contactContainerHeader}>
                            <div className={style.textHeader}>
								<label>
									<I18n>contactInformationTitle</I18n>
								</label>
							</div>
                            {
                                this.session.accessToken && !this.confirmAuthenticators && (
                                    <div class={style.editText}>
                                        <Button id="contact-edit" type='button' theme={"gray"} onClick={this.handleToggleEdit}>
                                            <img src={editIcon} alt="Edit Icon"/>
                                            <span>
                                                {
                                                    this.state.editing 
                                                    ? <I18n>cancel</I18n> 
                                                    :<I18n>edit</I18n>
                                                }
                                            </span>
                                        </Button>
                                     </div>
                                )
                            }
                        </div>
                        <div className={style.contactContainerBody}>
                            <Row class={style.infoRow}>
                                <Col class={style.infoCol}>
                                    <label class={`${style.colTitle} ${this.state.editing ? style.invertColor : "" }`}>
                                        {I18n.t("name").toUpperCase()}
                                    </label>
                                    {
                                        this.state.editing 
                                        ? (
                                            <div class={style.inputsContainer}>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        <I18n>firstName</I18n>
                                                    </div>
                                                    <FormEntry>
                                                        <InputDark required={true} name='firstName' id='firstName' question={I18n.t('firstName')} type='text' initialValue={this.account.firstName}  />
                                                    </FormEntry>
                                                </Col>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        <I18n>lastName</I18n>
                                                    </div>  
                                                    <FormEntry>
                                                        <InputDark required={true} name='lastName' id='lastName' question={I18n.t('lastName')} type='text' initialValue={this.account.lastName} />
                                                    </FormEntry>
                                                </Col>
                                            </div>
                                        )
                                        : (
                                            <label>
                                            { `${this.account.firstName} ${this.account.lastName}`}
                                            </label>
                                        )
                                        
                                    }
                                </Col>
                            </Row>
                            <Row class={style.infoRow}>
                                <Col class={style.infoCol}>
                                    <label class={`${style.colTitle} ${style.invertColor}`}>
                                        {I18n.t("contact").toUpperCase()}
                                    </label>
                                    {
                                        this.state.editing 
                                        ? (
                                            <div class={style.inputsContainer}>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        {I18n.t("email").toUpperCase()}
                                                    </div>
                                                    <FormEntry>
                                                        <InputDark required={true} name='email' id='email' question={I18n.t('email')} type='email' initialValue={this.account.email} onChange={this.handleEmailChange}/>
                                                    </FormEntry>
                                                    {this.state.emailError &&
                                                        <div class={style.errorMessage}>This email has already been used</div>	
                                                    }
                                                </Col>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        {I18n.t("mobilePhone").toUpperCase()} 
                                                    </div> 
                                                    <FormEntry>
                                                        <MaskedInputDark 
                                                            required={true} 
                                                            name='mobilePhone' 
                                                            id='mobilePhone' 
                                                            question={I18n.t("mobilePhone")} 
                                                            type='tel' 
                                                            pattern="[0-9]{3}[\-][0-9]{3}[\-][0-9]{4}" 
                                                            initialValue={this.account.mobilePhone} 
                                                            onChange={this.handleMobileChange} 
                                                        />
                                                    </FormEntry>
                                                    <div className={style.otherInfo}>(e.g. 4435579282)</div>
                                                    {this.state.phoneError &&
                                                        <div class={style.errorMessage}>This phone number has already been used</div>	
                                                    }
                                                </Col>
                                            </div>
                                        )
                                        : (
                                            <div className={style.labelContainer}>
                                                <label className={style.item}>
                                                    <span className={style.itemTitle}>{I18n.t("email").toUpperCase()}</span>
                                                    <span  className={style.otherInfo}>{this.account.email}</span>
                                                </label>
                                                <label className={style.item}>
                                                    <span className={style.itemTitle}>{I18n.t("mobilePhone").toUpperCase()}</span> 
                                                    <span  className={style.otherInfo}>{formatPhoneNumber(this.account.mobilePhone)}</span>   
                                                    
                                                </label>
                                            </div>
                                        )
                                        
                                    }
                                </Col>
                            </Row>
                            <Row class={style.infoRow}>
                                <Col class={style.infoCol}>
                                    <label class={`${style.colTitle} ${this.state.editing ? style.invertColor : "" }`}>
                                        {I18n.t("address").toUpperCase()}
                                    </label>
                                    {
                                        this.state.editing 
                                        ? (
                                            <div class={style.inputsContainer}>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        <I18n>street</I18n>
                                                    </div>
                                                    <FormEntry>
                                                        <InputDark required={true} name='address' id='address' question={I18n.t('address')} type='text' initialValue={this.account.address} />
                                                    </FormEntry>
                                                </Col>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        <I18n>unit</I18n>
                                                    </div> 
                                                    <FormEntry>
                                                        <InputDark name='unit' id='unit' question={I18n.t('unit')} type='text' initialValue={this.account.unit} />
                                                    </FormEntry>
                                                </Col>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        <I18n>city</I18n>
                                                    </div> 
                                                    <FormEntry>
                                                        <InputDark required={true} name='city' id='city' question={I18n.t('city')} type='text' initialValue={this.account.city} />
                                                    </FormEntry>
                                                </Col>
                                                <Col class={style.item}>
                                                    <div className={style.itemTitle}>
                                                        <I18n>zipCode</I18n>
                                                    </div> 
                                                    <FormEntry>
                                                        <InputDark required={true} name='zip' id='zip' question={
                                                            this.organization.country === "US" ?
                                                            I18n.t('zipCode') 
                                                            : I18n.t('postalCode')
                                                            } type='text' initialValue={this.account.zip} />
                                                    </FormEntry>
                                                </Col>
                                            </div>
                                        )
                                        : (
                                            <label>
                                                {this.account.address} {this.account.unit}
                                                <br />
                                                {this.account.city}, {this.account.state} {this.account.zip}
                                            </label>
                                        )
                                    }
                                </Col>
                            </Row>
                            {this.customFields.length > 0 && (
                                <Row class={style.infoRow}>
                                    <Col class={style.infoCol}>
                                        <label class={`${style.colTitle} ${style.invertColor}`}>
                                            {I18n.t("extraFields").toUpperCase()}
                                        </label>
                                    {this.customFields.map((customField)=>{
                                        if(!this.newPatient && !this.state.editing && !this.account[customField.key] && !customField.required){
                                            return
                                        }
                                        return (
                                            <Fragment>  
                                                {!this.newPatient && !this.state.editing?
                                                    <div className={style.labelContainer}>
                                                        <label className={style.item}>
                                                            <span className={style.itemTitle}>{customField.label}</span>
                                                            <span  className={style.otherInfo}>{!_.isNil(this.account[customField.key]) ? `${this.account[customField.key]}` : 'none'}</span>
                                                        </label>
                                                    </div>
                                                :
                                                    <div class={style.inputsContainer}>
                                                        <Col class={style.item}>
                                                            {customField.type !== 'Boolean' &&
                                                                <div className={style.itemTitle}>
                                                                    {customField.label}
                                                                </div>
                                                            }
                                                            <FormEntry >
                                                                {customField.type == 'Boolean' &&
                                                                    <Toggle class={style.customToggle} selected={this.state.customBooleans[customField.key]} onSelect={this.handleToggleCustomField.bind(this, customField)}>
                                                                        {customField.label}
                                                                    </Toggle>
                                                                }
                                                                {customField.dropdownOptions && customField.dropdownOptions.length > 0 &&
                                                                    <SelectDark 
                                                                        required={customField.required} 
                                                                        name={customField.key}
                                                                        id={customField.key} 
                                                                        data={customField.dropdownOptions} 
                                                                        placeholder={customField.label} 
                                                                        initialValue={this.account[customField.key]} 
                                                                    />
                                                                }	
                                                                {(!customField.dropdownOptions || customField.dropdownOptions.length == 0) && customField.type != 'Boolean' &&
                                                                    <InputDark
                                                                        required={customField.required}
                                                                        type={mapInputType[customField.type]}
                                                                        step={customField.type == 'Float' && .01}
                                                                        name={customField.key}
                                                                        question={customField.label}
                                                                        initialValue={this.account[customField.key]}
                                                                        onChange={this.handleColorChange} 
                                                                    />
                                                                }
                                                            </FormEntry>
                                                        </Col>
                                                    </div>
                                                }
                                            </Fragment>
                                            )
                                        })}
                                        </Col>
                                    </Row>
                            )}

                            {
                                 this.state.editing && !this.account.id && (
                                    <Row class={style.infoRow}>
                                        <Col class={style.infoCol}>
                                            <label class={`${style.colTitle} ${this.state.editing ? style.invertColor : "" }`}>
                                                {I18n.t("password").toUpperCase()}
                                            </label>
                                            <div class={style.inputsContainer}>
                                                <Col class={style.item}>
                                                    <button className={style.showPasswordBtn} type="button" class={style.passwordButton} onClick={this.handleShowPassword}>
                                                       <img src={this.state.showPassword ? hideIcon : showIcon} alt='Show Password'/>
                                                    </button>
                                                    <FormEntry>
                                                        <InputDark name="password" onChange={this.handlePassword} required={true} question={I18n.t("password")} type={this.state.showPassword ? "text" : "password"} />
                                                    </FormEntry>
                                                </Col>
                                                <Col class={style.item}>
                                                    <button className={style.showPasswordBtn} type="button" class={style.passwordButton} onClick={this.handleShowPassword}>
                                                       <img src={this.state.showPassword ? hideIcon : showIcon} alt='Show Password'/>
                                                    </button>
                                                    <FormEntry>
                                                        <InputDark name="passwordConfirmation" onChange={this.handlePasswordConfirmation} required={true} question={I18n.t("passwordConfirmation")} type={this.state.showPassword ? "text" : "password"} />
                                                    </FormEntry>
                                                </Col>
                                                <Col class={style.item}>
                                                    <div className={`text-left ${style.passwordRules}`}>
                                                        <div className={style.rule}>
                                                            {this.state.hasNumber ?
                                                                <FACheckCircle class={style.checkedColor} /> :
                                                                <FADotCircle class={style.openColor} />
                                                            } <I18n>passwordRuleLeastNumber</I18n>
                                                        </div>
                                                        <div className={style.rule}>
                                                            {this.state.hasUpperCase ?
                                                                <FACheckCircle class={style.checkedColor} /> :
                                                                <FADotCircle class={style.openColor} />
                                                            } <I18n>passwordRuleLeastUppercaseLetter</I18n>
                                                        </div>
                                                        <div className={style.rule}>
                                                            {this.state.hasLowerCase ?
                                                                <FACheckCircle class={style.checkedColor} /> :
                                                                <FADotCircle class={style.openColor} />
                                                            } <I18n>passwordRuleLeastLowercaseLetter</I18n>
                                                        </div>
                                                        <div className={style.rule}>
                                                            {this.state.hasEightCharacters ?
                                                                <FACheckCircle class={style.checkedColor} /> :
                                                                <FADotCircle class={style.openColor} />
                                                            }<I18n>passwordRuleLeastCharacters</I18n>
                                                        </div>
                                                        <div className={style.rule}>
                                                            {this.state.passwordConfirmationMatches ?
                                                                <FACheckCircle class={style.checkedColor} /> :
                                                                <FADotCircle class={style.openColor} />
                                                            }<I18n>passwordRuleConfirmationMatched</I18n>
                                                        </div>
                                                        {this.state.passwordError &&
                                                            <div class={style.passwordErrorMessage}>{this.state.passwordError}</div>	
                                                        }
                                                    </div>
                                                </Col>
                                            </div>
                                        </Col>
                                     </Row>
                                 )
                            }
                        </div>  
                    </div>          
                    {!this.organizationAccess && !this.componentIsLoading() &&
                        <Toggle class={style.grantToggle} selected={this.state.accessToggled} onSelect={this.handleToggleAccess}>
                            <I18n>iAgreeToGrant</I18n> <strong>{this.props.organization.name}</strong> <I18n>accessToInformation</I18n>
                        </Toggle>
                    }
                    {this.state.grantError &&
                        <div class={style.passwordErrorMessage}>{this.state.grantError}</div>	
                    }
                    {(this.state.editing || !this.organizationAccess) && 
                        <Button spinner={this.componentIsLoading()}>{this.session.accessToken?(
                            <I18n>update</I18n>
                        ):(
                            <I18n>next</I18n>
                        )}</Button>
                    }
                </Form>
                {this.confirmAuthenticators && (
                    <ConfirmAuthenticators 
                        confirmAuthenticators={this.confirmAuthenticators}
                        onSubmit={this.handleConfirmAuthenticatorsSubmit}
                    />
                )}
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./components/partials/ContactInformation/index.js